import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from '../_components';
import { useModal } from '../_contexts';
import { ChronicleSettingsForm } from './forms';

export function ChronicleSettings({ prevForm }) {
  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { details: world } = useSelector((state) => state.world);

  const { closeModal } = useModal();

  return (
    <Modal
      id="chronicleSettingsModal"
      // backdrop
      title="Chronicle Settings"
      icon="far fa-cogs fa-fw"
      size="md"
      open
      onClose={() => closeModal()}
    >
      <ChronicleSettingsForm
        chronicle={chronicle}
        world={world}
        prevForm={prevForm}
      />
    </Modal>
  );
}
